<template>
  <div class="DialogRePortCalls__Component">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">קריאות ריפורט</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <b-table v-if="calls.length" :data="calls" detailed detail-key="Id" :show-detail-icon="true"
          :opened-detailed="openedDetails" narrowed striped>
          <b-table-column field="StartTime" label="זמן">
            <template v-slot="props">
              <span class="ltr">{{ formatTime(props.row.StartTime) }}</span>
            </template>
          </b-table-column>
          <b-table-column field="Call" label="קריאה">
            <template v-slot="props">
              <span class="ltr">{{ shortCallName(props.row.Call) }}</span>
            </template>
          </b-table-column>
          <!-- תקשורת בלבד - ריפורט מחזיר כשלים עסקיים בתוך תשובה תקינה -->
          <b-table-column field="IsSuccessful" label="תקשורת">
            <template v-slot="props">
              <b-tag :type="props.row.IsSuccessful ? 'is-success' : 'is-danger'">
                {{ props.row.IsSuccessful ? 'תקין' : 'נכשל' }}
              </b-tag>
            </template>
          </b-table-column>
          <b-table-column field="HttpStatusCode" label="סטטוס">
            <template v-slot="props">
              <span class="ltr">{{ props.row.HttpStatusCode }}</span>
            </template>
          </b-table-column>
          <b-table-column field="DurationInSeconds" label="משך (שניות)">
            <template v-slot="props">
              <span class="ltr">{{ props.row.DurationInSeconds.toFixed(1) }}</span>
            </template>
          </b-table-column>
          <b-table-column field="RunId" label="מזהה ריצה">
            <template v-slot="props">
              <span class="ltr run-id" :title="props.row.RunId">{{ shortRunId(props.row.RunId) }}</span>
            </template>
          </b-table-column>

          <template #detail="props">
            <div class="payloads">
              <div v-if="props.row.ErrorMessage" class="payload">
                <div class="payload-head">
                  <span class="payload-title">שגיאה</span>
                </div>
                <pre class="ltr error">{{ props.row.ErrorMessage }}</pre>
              </div>
              <div class="payload">
                <div class="payload-head">
                  <span class="payload-title">בקשה</span>
                  <b-button size="is-small" @click="copy(props.row.Request)">העתק</b-button>
                </div>
                <pre class="ltr">{{ pretty(props.row.Request) }}</pre>
              </div>
              <div class="payload">
                <div class="payload-head">
                  <span class="payload-title">תשובה</span>
                  <b-button size="is-small" @click="copy(props.row.Response)">העתק</b-button>
                </div>
                <pre class="ltr">{{ pretty(props.row.Response) }}</pre>
              </div>
              <div v-if="props.row.LogFileName" class="log-file ltr">
                log: {{ props.row.LogFileName }}
              </div>
            </div>
          </template>
        </b-table>
        <h1 v-else>לא נמצאו קריאות עבור דוח זה</h1>
      </section>
      <footer class="modal-card-foot">
        <b-button label="סגור" @click="$emit('close')" />
      </footer>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

const EMPTY_PAYLOAD = '(ריק)';
const RUN_ID_PREFIX_LENGTH = 8;

export default {
  name: 'DialogRePortCalls',
  props: ['calls'],
  computed: {
    // the newest call arrives first - open it so the common case needs no click
    openedDetails() {
      return this.calls.length ? [this.calls[0].Id] : [];
    },
  },
  methods: {
    formatTime(value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
    shortCallName(call) {
      return call ? call.split('/').pop() : call;
    },
    shortRunId(runId) {
      return runId ? runId.substring(0, RUN_ID_PREFIX_LENGTH) : runId;
    },
    pretty(payload) {
      if (!payload) {
        return EMPTY_PAYLOAD;
      }
      try {
        return JSON.stringify(JSON.parse(payload), null, 2);
      } catch (e) {
        // truncated or non-json payloads are shown as they were recorded
        return payload;
      }
    },
    copy(payload) {
      if (!payload) {
        return;
      }
      navigator.clipboard.writeText(payload).then(() => {
        this.$buefy.toast.open({ message: 'הועתק', type: 'is-success' });
      }).catch(() => {
        this.$buefy.toast.open({ message: 'ההעתקה נכשלה', type: 'is-danger' });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.DialogRePortCalls__Component {
  ::v-deep .modal-card {
    width: 100% !important;
    height: 1000px;
  }

  ::v-deep .modal-card-body {
    overflow: auto;
  }
}

.ltr {
  direction: ltr;
  display: inline-block;
}

.run-id {
  font-family: monospace;
}

.payloads {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.payload-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.payload-title {
  font-weight: bold;
}

pre {
  direction: ltr;
  text-align: left;
  max-height: 300px;
  overflow: auto;
  background-color: #f5f5f5;
  padding: 8px;
  font-size: 12px;

  &.error {
    background-color: #ffecec;
  }
}

.log-file {
  font-size: 12px;
  color: #7a7a7a;
}
</style>
